var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M6.5 12.834.667 7 6.5 1.167"}));
}

Arrow.defaultProps = {"fill":"none","viewBox":"0 0 7 14"};

module.exports = Arrow;

Arrow.default = Arrow;
